import Image from 'next/image'
import styled from 'styled-components'

import Box from '@ilg-totallymoney/ui/components/Box'
import { focusStylesWithRoundedEdges } from '@ilg-totallymoney/ui/styles/focus'
import theme from '@ilg-totallymoney/ui/theme'

import TotallySureCornerLogo from '@images/TotallySure-corner-logo.png'

const StyledTotallySureCornerBanner = styled.button`
    cursor: pointer;
    border: none;
    padding: 0;
    overflow: hidden;
    z-index: 1000;
    right: 0;
    top: 0;
    background: transparent;
    position: absolute;
    border-top-right-radius: ${theme.radii.borderRadius20};
    ${focusStylesWithRoundedEdges};
`

const TotallySureCornerBanner = ({ onClick }: { onClick: () => void }) => (
    <StyledTotallySureCornerBanner onClick={onClick}>
        <Box width={[80, 110]}>
            <Image
                src={TotallySureCornerLogo}
                alt="TotallySure logo"
                style={{
                    width: '100%',
                    height: 'auto',
                }}
            />
        </Box>
    </StyledTotallySureCornerBanner>
)

export default TotallySureCornerBanner
